import {useState,useEffect} from 'react';
import {CardBody,CardTitle,Button} from 'reactstrap';
import Parametri from '../../parametri';
import SchedaAssemblee from '../SchedaAssemblee/SchedaAssemblee.js';
import TabellaRicerca from '../tabellaricerca.js';
import Clessidra from '../Clessidra.js';

const STATO_RICERCA_ELENCO = 1;
const STATO_ELENCO = 2;
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_VAI_IN_INSERISCI = 4;
const STATO_VAI_IN_MODIFICA = 5;

function TabellaAssemblee(props) {
    
  const [elencoAssemblee,setElencoAssemblee] = useState('');
  const [statoPagina,setStatoPagina] = useState(STATO_RICERCA_ELENCO);
  const [idElemento, setIdElemento] = useState(0);
  const [error,setError] = useState('');
  
  // nota: accessor DEVE chiamarsi così a causa di requisiti dei componenti usati, non fatti da me
  const colonne = [
    {
      etichetta: '',
      accessor: 'ID'
    },
    {
      etichetta: 'Data',
      accessor: 'DATA',
      pdf: 1,
    },
    {
      etichetta: 'Tipo',
      accessor: 'TIPO_ASSEMBLEA',
      pdf: 1,
    },
    {
      etichetta: "Argomento",
      accessor: 'TITOLO',
      pdf: 1,
    },
  ];
  const arrayTipiDati=[];

  useEffect(() => {
    if(statoPagina===STATO_RICERCA_ELENCO){
      // parametri per inviare i dati al server:
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({op:"assembleeElenco",tipo:props.tipo,emak: props.emak,sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreDiRitorno) => {
            if(valoreDiRitorno.risultatoOperazione===0){
              alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
            }
            if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
            if(valoreDiRitorno.risultatoOperazione===1){
              setElencoAssemblee(valoreDiRitorno.elenco);
              setStatoPagina(STATO_ELENCO);}
          },
        (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        );
    }    
  },[statoPagina])

  function eliminaAssemblea(id) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({op:"eliminaAssemblea",idElemento:id,emak: props.emak,sessionId:props.sessionId})
    };

    fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
      .then(risposta => risposta.json())
      .then(
        (valoreDiRitorno) => {
          if(valoreDiRitorno.risultatoOperazione===0){
            alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
          }
          if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
          if(valoreDiRitorno.risultatoOperazione===1){
            setStatoPagina(STATO_RICERCA_ELENCO);}
        },
      (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
      );
  }
  
  function VaiModifica(id) {
    setStatoPagina(STATO_VAI_IN_MODIFICA);
    setIdElemento(id);
  }

  function VaiElimina(id) {
    if (id===undefined) return;
    const assemblea = elencoAssemblee.find(a => a.ID === id);
    if (!assemblea) {
      window.alert("Assemblea non trovata");
      return;
    }
    
    const dataPulita = assemblea.DATA.replace(/<br\s*\/?>/gi, "\n");
    
    const messaggio = [
      `Sei sicuro di voler cancellare l'assemblea ${assemblea.TIPO_ASSEMBLEA} del`,
      dataPulita,
      "",
      `(${assemblea.TITOLO})`,
      "",
      "Tutti i dati, compresi convocazioni e verbali, andranno persi."
    ].join("\n");

    const confermato = window.confirm(messaggio);

    if (!confermato) return;

    eliminaAssemblea(id);
  }

  if (statoPagina == STATO_RICERCA_ELENCO) {
    return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}><Clessidra loading={true}/></div>)
  }

  if (statoPagina == STATO_ERRORE_CONNESSIONE) {
    return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Errore nell'elaborazione della richiesta</div>)
  }

  if (statoPagina == STATO_ELENCO) {
    return (
      <div style={{height: props.dimensioniApp.yMain, overflow:"hidden", display:"flex", flexDirection:"column"}}>
      <CardBody>
    
      <div>
        <CardTitle>Elenco assemblee {props.tipo=="soci" && " dei soci"}{props.tipo=="direttivo" && " del direttivo"}</CardTitle>
        <Button color="success" onClick={() => setStatoPagina(STATO_VAI_IN_INSERISCI)}>Nuova Assemblea</Button>
      </div>
      </CardBody>

      {elencoAssemblee ?
        <TabellaRicerca 
          titolo={`Elenco Assemblee`} 
          columns={colonne}
          data={elencoAssemblee}
          arrayTipiDati={arrayTipiDati}
          campoChiave={0}
          nascondiColonna={0}
          callbackSelezionaElemento={VaiModifica}
          callbackEliminaElemento={VaiElimina}
        />
      : 
        <div>Nessun dato presente</div>
      }
                    
    </div>
    )
  }

  if (statoPagina == STATO_VAI_IN_INSERISCI) {
    return (
      <SchedaAssemblee
        {...props}
        azione="ins"
        callback={() => setStatoPagina(STATO_RICERCA_ELENCO)}
      />
    );
  }

  if (statoPagina == STATO_VAI_IN_MODIFICA) {
    return (
      <SchedaAssemblee
        {...props}
        azione="mod"
        idElemento={idElemento}
        callback={() => setStatoPagina(STATO_RICERCA_ELENCO)}
      />
    );
  }
  
  return (<div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>Assemblee: Pagina non trovata ({statoPagina})</div>)
}
export default TabellaAssemblee;